module.exports = __webpack_public_path__ + "static/img/logo.db326c26.png";